"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgCloseButton = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, className: "close-button_svg__$state$" }, props),
    React.createElement("style", null),
    React.createElement("path", { d: "m7.7 7 4.7-4.7c.2-.2.2-.5 0-.7s-.5-.2-.7 0L7 6.3 2.3 1.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L6.3 7l-4.7 4.7c-.2.2-.2.5 0 .7s.5.2.7 0L7 7.7l4.7 4.7c.2.2.5.2.7 0s.2-.5 0-.7L7.7 7z", style: {
            fill: "#666",
        } })));
const Memo = (0, react_1.memo)(SvgCloseButton);
exports.default = Memo;
//# sourceMappingURL=CloseButton.js.map